import { useIsLoginUserQuery } from '~/__generated__/app/query/is-login-user.graphql'
import { useNolUserLinkageInfoQuery } from '~/__generated__/app/query/nol-user-linkage-info.graphql'

const useNolUserLinkageInfo = () => {
  const { data: loginData } = useIsLoginUserQuery()
  const { data: nolUserLinkageInfoData } = useNolUserLinkageInfoQuery({
    skip: !loginData?.isLoginUser,
  })

  return {
    isLinked: nolUserLinkageInfoData
      ? nolUserLinkageInfoData.memberInfoByCache.linkage.NOL.isLinked
      : false,
  }
}

export default useNolUserLinkageInfo
